module.exports = __webpack_public_path__ + "img/dzz-icon.5d2a3dad.png";